var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473.56,397.576V103.232c0-7.04-5.76-12.8-12.8-12.8H51.32c-7.04,0-12.8,5.76-12.8,12.8v294.352 C38.528,397.576,474.632,397.576,473.56,397.576z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 54.52,
    y: 106.432,
    style: {
      fill: "#E50914"
    },
    width: 403.04,
    height: 275.152
  }), /*#__PURE__*/React.createElement("rect", {
    y: 397.576,
    style: {
      fill: "#D8D8D8"
    },
    width: 511.912,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAAAAA"
    },
    points: "486.408,421.568 25.688,421.568 0.088,405.576 512,405.576 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M298.992,397.576H212.92c0.816,4.488,4.824,8,9.832,8h66.4 C294.168,405.576,298.176,402.064,298.992,397.576z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256,185.912c20.264,0,36.688,16.424,36.688,36.688S276.264,259.288,256,259.288 s-36.688-16.424-36.688-36.688S235.736,185.912,256,185.912z M197.904,335.992c0.632-35.04,26.376-63.256,58.096-63.256 s57.464,28.208,58.096,63.256H197.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M360.376,152.032c12.736,0,23.056,10.32,23.056,23.056s-10.32,23.064-23.056,23.064 s-23.056-10.32-23.056-23.056S347.64,152.032,360.376,152.032z M323.872,246.336c0.4-22.016,16.576-39.744,36.504-39.744 s36.104,17.728,36.504,39.744H323.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M151.624,152.032c12.736,0,23.056,10.32,23.056,23.056s-10.32,23.064-23.056,23.064 s-23.056-10.32-23.056-23.056C128.576,162.36,138.896,152.032,151.624,152.032z M115.12,246.336 c0.4-22.016,16.576-39.744,36.504-39.744s36.104,17.728,36.504,39.744H115.12z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersUser);
export default __webpack_public_path__ + "static/media/users-user.5306ff5d9c2c2371f2df57c66b300ca0.svg";
export { ForwardRef as ReactComponent };